/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../app/common/helper/avatar.component';
import * as i2 from '@angular/http';
const styles_AvatarComponent:any[] = ([] as any[]);
export const RenderType_AvatarComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_AvatarComponent,data:{}});
export function View_AvatarComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,[['img',1]],(null as any),0,'img',[['style',
      'border-radius:50%; display:inline-block; object-fit:cover;']],[[8,'src',4],
      [8,'alt',0],[8,'title',0],[8,'className',0],[8,'width',0],[8,'height',0]],[[(null as any),
      'error']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i1.AvatarComponent = _v.component;
    if (('error' === en)) {
      const pd_0:any = ((<any>(i0.ɵnov(_v,0).src = _co.temp_img)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any)))],(null as any),(_ck,_v) => {
    var _co:i1.AvatarComponent = _v.component;
    const currVal_0:any = (_co.src? (_co.outside? _co.src: (_co.src + (_co.size? _co.size: '_thumb_medium.jpg'))): _co.temp_img);
    const currVal_1:any = (_co.alt? _co.alt: _co.owner.social_name);
    const currVal_2:any = (_co.title? _co.title: _co.owner.social_name);
    const currVal_3:any = _co.class;
    const currVal_4:any = _co.width;
    const currVal_5:any = _co.height;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5);
  });
}
export function View_AvatarComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'ick-avatar',
      ([] as any[]),(null as any),(null as any),(null as any),View_AvatarComponent_0,
      RenderType_AvatarComponent)),i0.ɵdid(1,49152,(null as any),0,i1.AvatarComponent,
      [i2.Http],(null as any),(null as any))],(null as any),(null as any));
}
export const AvatarComponentNgFactory:i0.ComponentFactory<i1.AvatarComponent> = i0.ɵccf('ick-avatar',
    i1.AvatarComponent,View_AvatarComponent_Host_0,{alt:'alt',title:'title',class:'class',
        width:'width',height:'height',owner:'owner',size:'size'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3F1YW5ob2FuZy96ZW5pZnkvcmVwb3MvY2xpZW50LWZpbmFsL3NyYy9hcHAvY29tbW9uL2hlbHBlci9hdmF0YXIuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL3F1YW5ob2FuZy96ZW5pZnkvcmVwb3MvY2xpZW50LWZpbmFsL3NyYy9hcHAvY29tbW9uL2hlbHBlci9hdmF0YXIuY29tcG9uZW50LnRzIiwibmc6Ly8vVXNlcnMvcXVhbmhvYW5nL3plbmlmeS9yZXBvcy9jbGllbnQtZmluYWwvc3JjL2FwcC9jb21tb24vaGVscGVyL2F2YXRhci5jb21wb25lbnQudHMuQXZhdGFyQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9Vc2Vycy9xdWFuaG9hbmcvemVuaWZ5L3JlcG9zL2NsaWVudC1maW5hbC9zcmMvYXBwL2NvbW1vbi9oZWxwZXIvYXZhdGFyLmNvbXBvbmVudC50cy5BdmF0YXJDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8aW1nXG4gICAgKGVycm9yKT1cImltZy5zcmMgPSB0ZW1wX2ltZ1wiXG4gICAgI2ltZ1xuICAgIHN0eWxlPVwiYm9yZGVyLXJhZGl1czo1MCU7IGRpc3BsYXk6aW5saW5lLWJsb2NrOyBvYmplY3QtZml0OmNvdmVyO1wiXG4gICAgW3NyY109XCJzcmMgPyAob3V0c2lkZSA/IHNyYyA6IHNyYyArIChzaXplID8gc2l6ZSA6ICdfdGh1bWJfbWVkaXVtLmpwZycpKSA6IHRlbXBfaW1nXCJcbiAgICBbYWx0XT1cImFsdCA/IGFsdCA6IG93bmVyLnNvY2lhbF9uYW1lXCJcbiAgICBbdGl0bGVdPVwidGl0bGUgPyB0aXRsZSA6IG93bmVyLnNvY2lhbF9uYW1lXCJcbiAgICBbY2xhc3NdPVwiY2xhc3NcIlxuICAgIFt3aWR0aF09XCJ3aWR0aFwiXG4gICAgW2hlaWdodF09XCJoZWlnaHRcIlxuICAvPiIsIjxpY2stYXZhdGFyPjwvaWNrLWF2YXRhcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtNQUFBO01BQUE7SUFBQTtJQUFBO0lBQ0k7TUFBQTtNQUFBO0lBQUE7SUFESjtFQUFBOztJQUlJO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQVRKLFdBSUksVUFDQSxVQUNBLFVBQ0EsVUFDQSxVQUNBLFNBVEo7Ozs7b0JDQUE7TUFBQTtnQ0FBQSxVQUFBO01BQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/common/helper/avatar.component.ngfactory.ts